import script from "./PlIconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PlIconButton.vue?vue&type=script&setup=true&lang=js"

import "./PlIconButton.vue?vue&type=style&index=0&id=66198888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66198888"]])

export default __exports__